import { render, staticRenderFns } from "./ListServ.vue?vue&type=template&id=596cf7b5&"
import script from "./ListServ.vue?vue&type=script&lang=js&"
export * from "./ListServ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports